import React, { useState, useEffect } from 'react';
import './CookieBanner.css';

const STORAGE_KEY = 'ph_cookie_consent';

const COOKIES = [
  ['pricehuntify_sid', 'ESSENTIAL', 'Keeps you signed in. Expires after 30 days of inactivity. Cleared when you sign out.'],
  ['_ga', 'ANALYTICS', 'Google Analytics — distinguishes unique visitors. Expires after 2 years.'],
  ['_ga_G-NYVSZJWZSC', 'ANALYTICS', 'Google Analytics — stores session state. Expires after 2 years.'],
  ['(none for ads)', 'NOT SET', 'There are no ads, so there are no ad cookies.'],
];

function CookieBanner() {
  const [state, setState] = useState('hidden');

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) {
      setState('default');
    } else {
      setState('dismissed');
    }
  }, []);

  const dismiss = () => {
    localStorage.setItem(STORAGE_KEY, '1');
    setState('dismissed');
  };

  if (state === 'hidden') return null;

  if (state === 'dismissed') return null;

  if (state === 'expanded') {
    return (
      <div className="ck-expanded">
        <div className="ck-exp-top">
          <span className="ck-exp-kicker">◆ COOKIES · IN DETAIL</span>
          <button className="ck-collapse" onClick={() => setState('default')}>COLLAPSE ↑</button>
        </div>
        <div className="ck-exp-table">
          {COOKIES.map(([name, cls, body]) => (
            <div key={name} className="ck-exp-row">
              <span className="ck-exp-name">{name}</span>
              <span className={`ck-exp-class ck-exp-class--${cls === 'NOT SET' ? 'notset' : cls === 'ANALYTICS' ? 'analytics' : 'essential'}`}>{cls}</span>
              <span className="ck-exp-body">{body}</span>
            </div>
          ))}
        </div>
        <div className="ck-exp-footer">
          <button className="ck-ok" onClick={dismiss}>OK, got it</button>
        </div>
      </div>
    );
  }

  return (
    <div className="ck-bar">
      <span className="ck-label">◆ COOKIES</span>
      <span className="ck-text">
        We use cookies for sign-in and analytics (Google Analytics). No ads, no third-party trackers beyond that.{' '}
        <button className="ck-readmore" onClick={() => setState('expanded')}>Read more</button>
      </span>
      <button className="ck-ok" onClick={dismiss}>OK, got it</button>
    </div>
  );
}

export default CookieBanner;
